// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"b3e5fa81","1568":"48ef0737","3224":"a65d2d14","4838":"3b62a26c","5211":"33eb69d1","6805":"4a858ed8"}[chunkId] + ".chunk.css";
};